import { render } from "./RequestsSearchTable.vue?vue&type=template&id=35de177f"
import script from "./RequestsSearchTable.vue?vue&type=script&lang=js"
export * from "./RequestsSearchTable.vue?vue&type=script&lang=js"

import "./RequestsSearchTable.vue?vue&type=style&index=0&id=35de177f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__